import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";

const HEIGHTS = { sm: "h-4 sm:h-5 md:h-6", md: "h-[18px] sm:h-6 md:h-7", lg: "h-9 md:h-11" };

export const Logo = ({ size = "md", className = "" }) => {
  const { theme } = useTheme();
  const pill = theme !== "light";
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      aria-label="Assisto4U"
      className={`inline-flex items-center shrink-0 transition-transform duration-200 hover:scale-[1.02] ${
        pill ? "bg-white rounded-full px-2.5 sm:px-3.5 py-1.5 shadow-sm" : "px-1 py-1"
      } ${className}`}
    >
      <img
        src="/assisto4u-wordmark-v2.png"
        alt="Assisto4U"
        className={`${HEIGHTS[size] || HEIGHTS.md} w-auto object-contain select-none`}
        draggable="false"
      />
    </Link>
  );
};

export default Logo;
